import axiosInstance from "../config/axios";
import API_ENDPOINTS from "../config/endpoints";
import { transformCampaign } from "./campaignService";

// /temples page content: the "temples" CMS sections only.
export const getTemplesCms = async () => {
  const response = await axiosInstance.get(API_ENDPOINTS.GET_CMS_HOME, { params: { page: "temples" } });
  return Array.isArray(response?.data) ? response.data : [];
};

// Temple campaigns pinned in admin (Section Ordering → temples_featured), or the
// latest live Temples campaigns when nothing is pinned.
export const getFeaturedTemples = async () => {
  const response = await axiosInstance.get(API_ENDPOINTS.GET_SECTION_ORDERING("temples_featured"), {
    params: { category: "Temples", limit: 6 },
  });
  const raw = Array.isArray(response?.data) ? response.data : [];
  return raw.map(transformCampaign);
};

// "My contribution goes to" options for temple monthly giving: Temple's active
// sub-categories from admin → Categories, as [{ code, label }].
export const getTempleSubCategories = async () => {
  const response = await axiosInstance.get(API_ENDPOINTS.CATEGORY_SUB_CATEGORIES("temple"));
  return Array.isArray(response?.data) ? response.data : [];
};

// Temple campaign detail page content (admin → Temples → Temple Detail Pages), or null.
export const getTempleDetail = async (campaignId) => {
  const response = await axiosInstance.get(API_ENDPOINTS.TEMPLE_DETAILS(campaignId));
  return response?.data || null;
};

// Multipart: text fields and up to 5 `photos`.
export const submitTempleNomination = async (fields, photos = []) => {
  const formData = new FormData();
  Object.entries(fields).forEach(([key, value]) => formData.append(key, value ?? ""));
  photos.forEach((file) => formData.append("photos", file));
  return axiosInstance.post(API_ENDPOINTS.TEMPLE_NOMINATIONS, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
